/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner } from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';
import {
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSONTyped,
} from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';

/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
 */
export interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    /**
     * 
     */
    selections: Array<UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     */
    internal_selections?: Array<UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     */
    date?: string;
    /**
     * 
     */
    time?: string;
    /**
     * 
     */
    message?: string;
    /**
     * 
     */
    internal_message?: string;
    /**
     * 
     */
    phone_number?: string;
    /**
     * 
     */
    phone_number_extension?: string;
    /**
     * 
     */
    checkbox?: boolean;
}

/**
 * Check if a given object implements the UpdateLeadDecisionRequestBidirectionalActionDetailsDetails interface.
 */
export function instanceOfUpdateLeadDecisionRequestBidirectionalActionDetailsDetails(value: object): value is UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    if (!('selections' in value) || value['selections'] === undefined) return false;
    return true;
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'selections': ((json['selections'] as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'internal_selections': json['internal_selections'] == null ? undefined : ((json['internal_selections'] as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'date': json['date'] == null ? undefined : json['date'],
        'time': json['time'] == null ? undefined : json['time'],
        'message': json['message'] == null ? undefined : json['message'],
        'internal_message': json['internal_message'] == null ? undefined : json['internal_message'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'phone_number_extension': json['phone_number_extension'] == null ? undefined : json['phone_number_extension'],
        'checkbox': json['checkbox'] == null ? undefined : json['checkbox'],
    };
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSONTyped(value?: UpdateLeadDecisionRequestBidirectionalActionDetailsDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selections': ((value['selections'] as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'internal_selections': value['internal_selections'] == null ? undefined : ((value['internal_selections'] as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'date': value['date'],
        'time': value['time'],
        'message': value['message'],
        'internal_message': value['internal_message'],
        'phone_number': value['phone_number'],
        'phone_number_extension': value['phone_number_extension'],
        'checkbox': value['checkbox'],
    };
}

